import { Button, Dropdown } from "antd";
import React from "react";
import { DollarOutlined, PlusCircleOutlined, AppstoreAddOutlined } from "@ant-design/icons";

const BtnGroup = ({ openAddModal, setDrawerContent, setDrawerOpen }) => {
  const items = [
    {
      key: "2",
      icon: <PlusCircleOutlined />,
      label: "Add Expense",
    },
    {
      key: "3",
      icon: <AppstoreAddOutlined />,
      label: "Add Bulk Expense",
    },
  ];

  const handleMenuClick = ({ key }) => {
    switch (key) {
      case "2":
        setDrawerContent("single");
        setDrawerOpen(true);
        break;

      case "3":
        setDrawerContent("bulk");
        setDrawerOpen(true);
        break;

      default:
        break;
    }
  };

  return (
    <Dropdown
      menu={{
        items,
        onClick: handleMenuClick,
      }}
      placement="bottomLeft"
    >
      {/* Different color button */}
      <Button size="large" style={{ backgroundColor: "#722ed1", color: "#fff", borderColor: "#722ed1" }}>
        <DollarOutlined style={{ marginRight: 6 }} /> Add Expense
      </Button>
    </Dropdown>
  );
};

export default BtnGroup;
